
import axios from 'axios'
import getEnv from './env'
import { getCookie, getPara } from './util'
import { isMock, mockData } from '../api/mock/';
// require('axios-debug-log/enable')
// require('axios-debug-log')({
//   request: function (debug: any, config: any) {
//     debug('Request with: ', config)
//   },
//   response: function (debug: any, response: any) {
//     debug(
//       'Response with:',
//       response
//     )
//   },
//   error: function (debug: any, error: any) {
//     // Read https://www.npmjs.com/package/axios#handling-errors for more info
//     debug('Boom', error)
//   }
// })
const env = getEnv()

interface BaseUrl {
  [development: string]: string;
  test: string;
  preview: string;
  production: string;
}

const baseURLMap: BaseUrl = {
  development: '/', //'https://test.meemo.pro',
  test: 'https://test.meemo.pro',
  preview: 'https://pre.meemo.pro',
  production: 'https://m.meemo.pro'
}

let baseURL = baseURLMap[env]

const getInstance = (func: string, service = 'weekly', req = {}, context = {}, headers = {}) => {
  const config = {
    timeout: 10000,
    headers: {
      businessid: 'meemo-web',
      'content-type': 'application/json',
      'trpc-trans-info': JSON.stringify({"lang": getCookie('language') || 'en_US'}),
      'game_server_id': getCookie('game_server_id') || '',
      'gameversion': getCookie('gameversion') || getPara('gameversion', location.href)
    }
  }
  // 另外一个域名
  if ([
    'sns/club',
    'feed/feed',
    'comment/comment',
    'tournaments',
    'config',
    'sns/user',
    'sns/activity',
    'feed/audit',
    'achievement',
    'zone',
    'feed/list',
    'feed',
    'ugc/influence',
    'ugc',
    'qapm/report',
  ].includes(service)) {
    /**
     * 4个环境：
     * 国内 wow 测试1服   tapi.idc.meemo.club
     * 新加坡测试服       tapi.club.gpubgm.com
     * 先游服             papi.club.gpubgm.com
     * 正式服             api.club.gpubgm.com
     */
    if (env === 'test') {
      baseURL = 'https://tapi.club.gpubgm.com/';
      // // ugc接口测试环境使用内部环境，不用新加坡的
      // if (['ugc/influence'].includes(service)) {
      //   baseURL = 'https://tapi.idc.meemo.club';
      // }
      // 先兼容一下预发
      const serverEnv = getCookie('server_env');
      const serverMap = {
        'idc': 'https://tapi.idc.meemo.club',
        'idc2': 'https://tapi.idc2.meemo.club',
        'rc1': 'https://rc1api.club.gpubgm.com',
        'rc2': 'https://rc2api.club.gpubgm.com',
      } as any;
      if (getPara('pre', location.href)) {
        baseURL = 'https://papi.club.gpubgm.com';
      } else if (serverEnv && serverMap[serverEnv]) {
        baseURL = serverMap[serverEnv];
      }
    } else if (env !== 'development') {
      baseURL = 'https://api.club.gpubgm.com';
    } else {
      if (getPara('pre', location.href)) {
        baseURL = 'https://papi.club.gpubgm.com';
      }
    }

  } else {
    baseURL = baseURLMap[env];
  }


  context = JSON.parse(JSON.stringify(context))
  const instance = axios.create({
    ...config,
    baseURL
  })
  // // 添加请求拦截器
  // instance.interceptors.request.use(function (config) {
  //   // 在发送请求之前做些什么
  //   return config;
  // }, function (error) {
  //   // 对请求错误做些什么
  //   return Promise.reject(error);
  // });

  // // 添加响应拦截器
  // instance.interceptors.response.use(function (response) {
  //   // 2xx 范围内的状态码都会触发该函数。
  //   // 对响应数据做点什么
  //   console.log('****interceptors res:', response)
  //   return response;
  // }, function (error) {
  //   // 超出 2xx 范围的状态码都会触发该函数。
  //   // 对响应错误做点什么
  //   console.log('****interceptors error:', error)
  //   return Promise.reject(error);
  // });
  return instance
}


const get = async (func: string, service = 'weekly', req = {}, context = {}, headers = {}) => {
  const axiosIns = getInstance(func, service, req, context, headers);
  return axiosIns.get(`${service}/${func}`, { params: req })
  .then(res => res.data)
  .catch((e) => {
    throw e
  })
}

const post = async (func: string, service = 'weekly', req = {}, context = {}, headers:any = {}) => {
  console.log('req:', req, 'context:', context, 'headers:', headers);
  const axiosIns = getInstance(func, service, req, context, headers);
  let body = {
    // args: { req },
    ...req,
    // service,
    // func,
    // context
  }
  if (headers['Content-Type'] === 'multipart/form-data') {
    body = req;
  }
  if (isMock) {
    return (mockData as any)[`${service}/${func}`];
  }
  // 先兼容一下kaden的转发后台预发环境，后续再申请域名机器部署预发布环境
  if (getPara('pre', location.href) && func.indexOf('certification_') !== -1) {
    func = `${func}_pre`;
  }
  console.log('http post:', body, headers);
  return axiosIns.post(`${service}/${func}`, body, { headers })
    .then(res => res.data)
    .catch((e) => {
      throw e
    })
}

const http = {
  get,
  post
}

export default http
